import { useRouter } from 'next/router';
import { FC, useCallback, useEffect, useState } from 'react';
import Button from './Button';
import useShortcuts from './hooks/useShortcuts';
import Modal from './Modal';
import useUser from '@utils/context/user';
import useAmplitude from '@utils/hooks/useAmplitude';
import { TrackingEventName } from '@utils/types/amplitude/events';

interface QuickSearchProps {
    clientOs?: string;
}

const QuickSearch: FC<QuickSearchProps> = ({ clientOs }) => {
    const [open, setOpen] = useState<boolean>(false);
    const router = useRouter();
    const { events } = router;
    const { track } = useAmplitude();
    const { info: user } = useUser();

    const handleOpen = useCallback(() => {
        track({
            name: TrackingEventName.HEADER_QUICK_SEARCH_CLICKED,
            params: {
                logged_user: Boolean(user),
            },
        });
        setOpen(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    useShortcuts({ onClose: handleClose, onOpen: handleOpen });

    // Unfocus previous element after modal is closed.
    // By default, focus is moved to the last focused element after modal is closed.
    useEffect(() => {
        if (!open) {
            (document.activeElement as HTMLElement).blur();
        }
    }, [open]);

    // handle close modal on route change (eg result clicked)
    useEffect(() => {
        const handleRouteChange = () => {
            setOpen(false);
        };

        events.on('routeChangeStart', handleRouteChange);

        return () => {
            events.off('routeChangeStart', handleRouteChange);
        };
    }, [events]);

    return (
        <>
            <Button clientOs={clientOs} onClick={handleOpen} />
            <Modal onClose={handleClose} open={open} />
        </>
    );
};

export default QuickSearch;
